import { memo } from "react";
import { useTranslate } from "helpers";

import { Modal } from "ui/components/Modal";
import ModalHeader from "ui/components/Modal/ModalHeader";
import ModalBody from "ui/components/Modal/ModalBody";
import { Dropdown } from "ui/components/Dropdown/Dropdown";
import { Button } from "ui/components/Button/Button";
import { ZPosition } from "ui/components/Modal/types";

interface TireAddQuantityModalProps {
    show: boolean;
    quantity: number | null;
    fromTireSet?: boolean;
    maxQuantity?: number;
    errors?: any;
    onQuantityChange: (e: any, name: string, item: any) => void;
    onSubmit: (e: any) => void;
    onClose: () => void;
}

const TireAddQuantityModal: React.FC<TireAddQuantityModalProps> = (props) => {
    const { show, quantity, fromTireSet, maxQuantity = 4, errors, onQuantityChange, onSubmit, onClose } = props;
    const { t } = useTranslate();

    return (
        <Modal show={show} onHide={onClose} size="small" position="centered" zPosition={ZPosition.Top}>
            <ModalHeader
                icon="/media/images/add-icon.svg"
                title={t("admin.fleet.tire.add.quantity.title")}
                onHide={onClose}
            />
            <ModalBody>
                <div className="p-4">
                    <div className="flex gap-4">
                        <div className="flex flex-1 mb-3">
                            <div className="flex-1">
                                <Dropdown
                                    name="quantity"
                                    label={t("admin.fleet.tire.add.quantity")}
                                    placeholder={t("admin.fleet.tire.add.quantity.placeholder")}
                                    options={[
                                        { value: 1, text: "1 kom" },
                                        { value: 2, text: "2 kom" },
                                        { value: 3, text: "3 kom" },
                                        { value: 4, text: "4 kom" },
                                    ].filter(o => Number(o.value) <= maxQuantity && (!fromTireSet || Number(o.value) % 2 === 0 || maxQuantity < 2))}
                                    value={quantity}
                                    onChange={onQuantityChange}
                                    error={errors?.quantity}
                                    width="full"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="px-4 py-3 fixed left-0 bottom-0 bg-slate-50 border border-t-slate-200 w-full flex justify-end gap-3">
                        <Button
                            variant="outlined"
                            children={t("admin.close")}
                            onClick={onClose}
                        />
                        <Button
                            variant="primary"
                            children={t("admin.save")}
                            onClick={onSubmit}
                        />
                    </div>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default memo(TireAddQuantityModal);
